import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopupType } from './popup-type.enum';

export interface PopupData {
    headerMessage?: string;
    message?: string;
    type: PopupType;
    okLabel?: string;
    cancelLabel?: string;
    okClass?: string;
    cancelClass?: string;
}

@Component({
    selector: 'app-popup-modal',
    templateUrl: './popup-modal.component.html',
    styleUrls: ['./popup-modal.component.scss'],
})
export class PopupModalComponent {
    PopupType: typeof PopupType = PopupType;

    constructor(
        public dialogRef: MatDialogRef<PopupModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PopupData,
    ) {}
}
